import {isMacOS} from '@github-ui/get-os'
import {colorNames} from '@github-ui/use-named-color'

import type {NewSingleSelectOption, SingleSelectOptionWithId} from './types'

const NEW_SINGLE_SELECT_OPTION_ID_MATCHER = 'single-select-option'

export const isPlatformMeta = (e: React.MouseEvent | React.KeyboardEvent | PointerEvent): boolean => {
  // eslint-disable-next-line @github-ui/ui-commands/no-manual-shortcut-logic
  return isMacOS() ? e.metaKey : e.ctrlKey
}

export const buildNewSingleSelectOption = (
  id: number,
  option: NewSingleSelectOption,
  options: SingleSelectOptionWithId[],
) => {
  // filter options to see if one option has color
  if (option.color === 'GRAY' && options.some(o => o.color !== 'GRAY')) {
    const availableColors = colorNames.slice(1) // remove gray

    const randomColor = availableColors[Math.floor(Math.random() * availableColors.length)] || 'PURPLE'
    option = {...option, color: randomColor}
  }
  return {...option, id: `${NEW_SINGLE_SELECT_OPTION_ID_MATCHER}-${id}`}
}
